import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TeamItem from './TeamItem';

import './TeamCommon.scss';

class TeamCommon extends Component {
  render () {
    return (
      <div className='teamCommon'>
        <div className='content-item'>
          <div className='item-title'>
            <i className='iconfont icon-zhucekehu'></i>注册客户
          </div>
          <TeamItem
            keyArr={['总注册客户', '当月注册客户', '今日注册客户']}
            itemObj={this.props.teamData.registerData}>
          </TeamItem>
        </div>
        <div className='content-item'>
          <div className='item-title'>
            <i className='iconfont icon-huoekehu'></i>获额客户
          </div>
          <TeamItem
            keyArr={['总获额客户', '当月获额客户', '今日获额客户']}
            itemObj={this.props.teamData.passQuotaData}>
          </TeamItem>
        </div>
        <div className='content-item'>
          <div className='item-title'>
            <i className='iconfont icon-tixiankehu'></i>首提客户
          </div>
          <TeamItem
            keyArr={['总首提客户', '当月首提客户', '今日首提客户']}
            itemObj={this.props.teamData.firstWithdrawData}>
          </TeamItem>
        </div>
        {/*<div className='content-item'>*/}
        {/*   <div className='item-title'>*/}
        {/*     <i className='iconfont icon-fenqikehu'></i>分期客户*/}
        {/*   </div>*/}
        {/*  <TeamItem*/}
        {/*    keyArr={['总分期客户', '当月分期客户', '今日分期客户']}*/}
        {/*    itemObj={this.props.teamData.instalmentsData}>*/}
        {/*  </TeamItem>*/}
        {/*</div>*/}
        {this.props.isGroupHome &&
          <div>
            {/* <div className='content-item'>*/}
            {/*   <div className='item-title'>*/}
            {/*     <i className='iconfont icon-fenqijine'></i>分期金额*/}
            {/*/!*  </div>*!/*/}
            {/*  <TeamItem*/}
            {/*    keyArr={['总分期金额', '当月分期金额', '今日分期金额']}*/}
            {/*    itemObj={this.props.teamData.stageAmountData}*/}
            {/*    isAmount>*/}
            {/*  </TeamItem>*/}
            {/*</div>*/}
            <div className='content-item'>
              <div className='item-title'>
                <i className='iconfont icon-fenqijine'></i>首提金额
              </div>
              <TeamItem
                keyArr={['总首提金额', '当月首提金额']}
                itemObj={this.props.teamData.firstWithdrawAmountData}
                isAmount>
              </TeamItem>
            </div>
          </div>
        }
        <div className='content-item'>
          <div className='item-title'>
            <i className='iconfont icon-tixiankehu'></i>提现客户
          </div>
          <TeamItem
            keyArr={['总提现客户', '当月提现客户', '今日提现客户']}
            itemObj={this.props.teamData.withdrawData}>
          </TeamItem>
        </div>
        <div className='content-item'>
          <div className='item-title'>
            <i className='iconfont icon-fenqijine'></i>提现金额
          </div>
          <TeamItem
            keyArr={['总提现金额', '当月提现金额']}
            itemObj={this.props.teamData.withdrawAmountData}
            isAmount>
          </TeamItem>
        </div>
      </div>
    )
  }
}

TeamCommon.propTypes = {
  teamData: PropTypes.object.isRequired,
  isGroupHome: PropTypes.bool
}

export default TeamCommon;
